module.exports = __webpack_public_path__ + "static/img/SearchDetailWork3.308a1b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailWork3.png
// module id = 779
// module chunks = 0